import { Component, HostListener, ViewChild, ElementRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrl: './home-two.component.css'
})
export class HomeTwoComponent {
   @ViewChild('localVideo', { static: false }) localVideo!: ElementRef<HTMLVideoElement>;
 isVideoPlaying = false;

  playVideo() {
    const video = this.localVideo.nativeElement;
    this.isVideoPlaying = true; // hide play button
    video.style.display = 'block';
    video.play();
  }
customOptions: OwlOptions = {
  loop: true,
  dots: true,
  nav: false,
  autoplay: true,
  autoplayTimeout: 2500,
  autoplayHoverPause: true,
  items: 1,
  smartSpeed: 1500 // Controls the swipe speed - adjust as needed
};

slideStore = [
  {
    introtext: "Objekt B Residence",
    subtitle: "Luksuzni apartmani 50 m od mora s pogledom na marinu",
    image: "assets/images/slides/home-bg-19.jpg",
  },
  {
    introtext: "SeaView Omiš Residence",
    subtitle: "ekskluzivni stambeni projekt iznad Omiša",
    image: "assets/images/slides/home-bg-20.jpg",
  }
];


 slideImages = [
  'assets/images/zatoglav-slike/background.jpg',
  'assets/images/zatoglav-slike/bg2.jpg',
  'assets/images/zatoglav-slike/bg3.jpg',
  'assets/images/zatoglav-slike/bg4.jpg',
  'assets/images/zatoglav-slike/bg5.jpg',
  'assets/images/zatoglav-slike/bg6.jpg',
  'assets/images/zatoglav-slike/bg7.jpg',
  'assets/images/zatoglav-slike/bg8.jpg',
  'assets/images/zatoglav-slike/bg9.jpg',
];
slideImages3 = [
  'assets/images/zatoglav-slike/omis-zgrada/1.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/2.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/3.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/4.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/5.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/6.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/7.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/8.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/9.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/10.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/11.jpg',
  'assets/images/zatoglav-slike/omis-zgrada/12.jpg',
];
 slideImages2 = [
  'assets/images/zatoglav-slike/maketa/0.png',
 'assets/images/zatoglav-slike/maketa/1.png',
 'assets/images/zatoglav-slike/maketa/2.png',
 'assets/images/zatoglav-slike/maketa/3.png',
 'assets/images/zatoglav-slike/maketa/4.png',
 'assets/images/zatoglav-slike/maketa/5.png',
 'assets/images/zatoglav-slike/maketa/6.png',
 'assets/images/zatoglav-slike/maketa/7.png',
 'assets/images/zatoglav-slike/maketa/8.png',
 'assets/images/zatoglav-slike/maketa/9.png',
 'assets/images/zatoglav-slike/maketa/10.png',
 'assets/images/zatoglav-slike/maketa/11.png',
 'assets/images/zatoglav-slike/maketa/12.png',
 'assets/images/zatoglav-slike/maketa/13.png',
 'assets/images/zatoglav-slike/maketa/14.png',
 'assets/images/zatoglav-slike/maketa/15.png',
 'assets/images/zatoglav-slike/maketa/16.png',
 'assets/images/zatoglav-slike/maketa/17.png',
 'assets/images/zatoglav-slike/maketa/18.png',
 'assets/images/zatoglav-slike/maketa/19.png',
 'assets/images/zatoglav-slike/maketa/20.png',
 'assets/images/zatoglav-slike/maketa/21.png',
 'assets/images/zatoglav-slike/maketa/22.png',
 'assets/images/zatoglav-slike/maketa/23.png',
 'assets/images/zatoglav-slike/maketa/24.png',
 'assets/images/zatoglav-slike/maketa/25.png',
 'assets/images/zatoglav-slike/maketa/26.png',
 'assets/images/zatoglav-slike/maketa/27.png'

];


  // Features
  features =[
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-six center-feature white-color border-radius-25",
      icon: "icon-envelope font-40px",
      title: "E-mail kontakt",
      desc:"E-mail: aquaconcept10@gmail.com",
    },
     {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient center-feature white-color border-radius-25",
      icon: "icon-phone font-40px",
      title: "Telefonski broj",
      desc:"Miran <br> Telefon (BiH): ‪+387 63 407 660‬ (WhatsApp / Viber) <br> Telefon (HR): ‪+385 97 643 6386‬",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient center-feature white-color border-radius-25",
      icon: "icon-globe font-40px",
      title: "Društvene mreže",
      desc:"Instagram, Facebook, Twitter...",
    }
  ]
    features2 =[
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-six center-feature white-color border-radius-25",
      icon: "icon-layers font-40px",
      title: "Objekt B Residence",
      desc:"•	Lokacija: Šibenska Rogoznica<br>•	Udaljenost od mora: 50 m<br>•	Broj zgrada: 2<br>•	Broj apartmana: 8<br>•	Kvadrature: od 75 m² do 116 m²<br>•	Katnost:  prizemlje + 2 kata<br>•	Broj spavaćih soba: 2 / 3 (ovisno o tipu)<br>•	Parkirna mjesta: 8(otvorena)<br>•	Status gradnje: u postupku ishodjenja građ. dozvola<br>•	Cijene: od 4900-5400 EUR<br>•	Planirani rok useljavanja: 6/2027",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient center-feature white-color border-radius-25",
      icon: "icon-layers font-40px",
      title: "SeaView Omiš Residence",
      desc:"•	Lokacija: Omiš, Dalmacija<br>•	Udaljenost od mora: cca 600 m<br>•	Broj apartmana: 10<br>•	Kvadrature: od 30 m² do 90 m²<br>•	Katnost:  prizemlje + 2 kata<br>•	Parkirna mjesta: privatna (12 garažnih mjesta)<br>•	Status gradnje: u postupku izdavanja dozvola<br>•	Cijene: od 3800-4200 EUR<br>•	Planirani rok useljavanja: 10/2027<br>• Energetski razred: A",
    }
  ]
  // Our Process
  steps = [
    {
      icon: "icon-briefcase default-color font-30px",
      title:"3",
      desc:"Projekata"
    },
    {
       icon: "icon-tools default-color font-30px",
      title:"18",
      desc:"Stanova"
    },
    {
      icon: "icon-layers default-color font-30px",
      title:"3",
      desc:"Poslovnih prostora"
    },
    {
      icon: "icon-clock default-color font-30px",
      title:"3+",
      desc:"Godina sa vama"
    },
  ]

  // Team
  
  slideStoreTwo: { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Web Designer",
      subtitle: "Tom Bills",
      image: "team-1.jpg",
      index: 0
    },
    {
      title: "CEO of Becki Agency",
      subtitle: "Sara Adams",
      image: "team-2.jpg",
      index: 1
    },
    {
      title: "Photographer",
      subtitle: "Enzo William",
      image: "team-3.jpg",
      index: 2
    }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook'] },
    { iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter'] },
    { iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest'] },
  ];

  // Services
  services = [
    {
      icon: "icon-tools font-30px white-color",
      title: "Branding",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-linegraph font-30px white-color",
      title: "Marketing",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-globe font-30px white-color",
      title: "Development",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-tools font-30px white-color",
      title: "Web Design",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-beaker font-30px white-color",
      title: "Social Media",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-layers font-30px white-color",
      title: "Research",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
  ]

  // Portfolio
  portfolios = [
    {
      img: "1.jpg",
      title: "Fode ",
      subTitle: "Branding, Mockup"
    },
    {
      img: "2.jpg",
      title: "Daniel and Denise",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "3.jpg",
      title: "Sydney Design",
      subTitle: "Design, Stationery"
    },
    {
      img: "4.jpg",
      title: "Glasses",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "5.jpg",
      title: "The Bijou Factory",
      subTitle: "Branding, Mockup"
    },
    {
      img: "6.jpg",
      title: "Calender",
      subTitle: "Design, Branding"
    },
    {
      img: "7.jpg",
      title: "Flyer",
      subTitle: "Branding, Stationery"
    },
    {
      img: "8.jpg",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    }
  ]

  // Pricing
  pricing = [
    {
      title: "Basic Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 9.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Standard Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 16.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Extended Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 24.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
          nav:false
      },
      1000:{
          items:3,
      }
    }
  }

 slideStoreThree = [
  {
    title: "Ivana Horvat",
    description: "Kupnja stana preko ove agencije bila je iznenađujuće jednostavna. Agent je uvijek bio dostupan za sva pitanja, a svi papiri su riješeni brzo i bez stresa. Toplo preporučujem!",
    image: "assets/images/team/avatar-1.jpg",
  },

  {
    title: "Marko Kovačić",
    description: "Prvo nisam bio siguran koji stan odabrati, ali zahvaljujući savjetima agenata pronašao sam savršeni dom za svoju obitelj. Svaka preporuka za profesionalnost i strpljenje.",
    image: "assets/images/team/avatar-2.jpg",
  },

  {
    title: "Ana Petrović",
    description: "Osjećala sam se potpuno sigurno tijekom cijelog procesa kupnje. Agentica je objasnila svaki detalj i pomogla mi da se odlučim bez ikakvih briga. Zaista sjajno iskustvo!",
    image: "assets/images/team/avatar-3.jpg",
  },

  {
    title: "Luka Babić",
    description: "Stan koji sam kupio je točno onakav kakav sam tražio. Agencija je organizirala sve vrlo profesionalno i sve je išlo glatko, od pregovora do potpisa ugovora.",
    image: "assets/images/team/avatar-4.jpg",
  }
];


  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/1.png",
    },

    {
      image: "assets/images/clients/2.png",
    },

    {
      image: "assets/images/clients/3.png",
    },

    {
      image: "assets/images/clients/4.png",
    },

    {
      image: "assets/images/clients/5.png",
    },

    {
      image: "assets/images/clients/6.png",
    }

  ]



  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'contact-form';  // Replace with your EmailJS Service ID
  private templateId = 'contact-form-becki';  // Replace with your EmailJS Template ID
  private publicKey = 'gObMl0a3V0Jib9k5c';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "fb",
      icon:"icofont icofont-social-facebook"
    },
    {
      iconClass: "ins",
      icon:"icofont icofont-social-instagram"
    }
  ]

  // Skills
  skills = [
    { name: 'HTML', level: 90 },
    { name: 'CSS', level: 80 },
    { name: 'JavaScript', level: 85 },
    { name: 'Angular', level: 75 },
    { name: 'TypeScript', level: 70 }
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }
}
